<template>
  <div>
    <div class="container-fluid">
      <div class="row smart-tracs-wrapper">
        <div class="col-12 col-lg-4">
          <div class="card">
            <div class="card-header">
              <h5>Create New SMARTrac</h5>
            </div>
            <div class="card-body">
              <form @submit.prevent="handleSubmit">
                <div class="form-group">
                  <label>Title</label>
                  <input type="text"
                    v-model="trac.title"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.trac.title.$error }" />
                  <div v-if="submitted && !$v.trac.title.required" class="invalid-feedback">
                    Title is required
                  </div>
                </div>
                <div class="form-group">
                  <label>Category</label>
                  <multiselect
                    v-model="trac.categoryIds"
                    :class="{ 'is-invalid': submitted && $v.trac.categoryIds.$error }"
                    tag-placeholder="Add this as new tag"
                    placeholder="You Can Choose More Than One"
                    label="text"
                    track-by="value"
                    :options="categoriesOptions"
                    :multiple="true"
                    :taggable="true"
                  ></multiselect>
                  <div v-if="submitted && !$v.trac.categoryIds.required" class="invalid-feedback">
                    Category is required
                  </div>
                </div>
                <div v-if="userIsAdmin()" class="form-group">
                  <label>Author</label>
                  <b-form-select class="form-control form-control-primary btn-square"
                    v-model="trac.lifeCoachId"
                    :options="authorsOptions"
                    :class="{ 'is-invalid': submitted && $v.trac.lifeCoachId.$error }">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select an Author --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <div v-if="submitted && !$v.trac.lifeCoachId.required" class="invalid-feedback">
                    Author is required
                  </div>
                </div>
                <div class="form-group">
                  <label>Price</label>
                  <input type="number"
                    v-model="trac.price"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.trac.price.$error }"
                    min="0" step=".01" />
                  <div v-if="submitted && !$v.trac.price.required" class="invalid-feedback">
                    Price is required
                  </div>
                </div>
                <div class="form-group">
                  <label>Brief Description</label>
                  <input type="text"
                    v-model="trac.briefDescription"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.trac.briefDescription.$error }" />
                  <div v-if="submitted && !$v.trac.briefDescription.required" class="invalid-feedback">
                    Brief Description is required
                  </div>
                </div>
                <div class="form-group">
                  <label>Full Description</label>
                  <textarea v-model="trac.fullDescription"
                    rows="4" class="form-control"
                    :class="{ 'is-invalid': submitted && $v.trac.fullDescription.$error }"></textarea>
                  <div v-if="submitted && !$v.trac.fullDescription.required" class="invalid-feedback">
                    Full Description is required
                  </div>
                </div>
                <div v-if="userIsAdmin()" class="row mb-4">
                  <div class="col-6">
                    <div class="checkbox checkbox-dark">
                      <div class="custom-control custom-checkbox pl-1">
                        <b-form-checkbox
                          v-model="trac.isFeatured"
                        >Featured</b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button class="btn btn-primary" :disabled="loadingCreate">Create</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8">
          <div>
            <div class="card">
              <i class="fa fa-question help-circle-icon-middle" @click="recognition = true"></i>
              <div class="bg-primary b-r-4 card-body">
                <div class="media static-top-widget">
                  <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                  <div class="media-body">
                    <h4 v-if="userIsAdmin()" class="mb-0 counter">
                      All SMARTracs
                    </h4>
                    <h4 v-else class="mb-0 counter">
                      {{userInfo.firstName}} {{userInfo.lastName}}'s SMARTracs
                    </h4>
                    <feather type="users" class="icon-bg"></feather>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="mb-4">
                  <h6 class="f-w-600">Search SMARTracs</h6>
                </div>
                <div class="row">
                  <div v-if="userIsAdmin()"
                    class="col-12 col-sm-6 col-xl-3 mb-3">
                    <label>Author</label>
                    <b-form-select :disabled="loading" class="form-control form-control-primary btn-square" v-model="search.author" :options="authorsOptions"
                      @change="getTracs()">
                      <template #first>
                        <b-form-select-option :value="null">-- All authors --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </div>
                  <div class="col-12 col-sm-6 col-xl-3 mb-3">
                    <label>Category</label>
                    <b-form-select :disabled="loading" class="form-control form-control-primary btn-square" v-model="search.category" :options="categoriesOptions"
                      @change="getTracs()">
                      <template #first>
                        <b-form-select-option :value="null">-- All categories --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </div>
                  <div class="col-12 col-sm-6 col-xl-3 mb-3">
                    <label>Search Term</label>
                    <input :disabled="loading" type="text" class="form-control" v-model="search.term" @keyup.enter="getTracs()" />
                  </div>
                  <div class="col-12 col-sm-6 col-xl-3 mb-3"
                    v-if="!userIsAdmin()">
                  </div>
                  <div class="col-12 col-sm-6 col-xl-3 mb-3 d-flex align-items-end justify-content-end">
                    <button :disabled="loading" class="btn btn-primary btn-block" @click="getTracs()">
                      <i class="fa fa-search"></i> &nbsp; Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <Loading v-if="loading" style="height: 400px" />
            <div v-else>
              <div v-if="tracs.records.length == 0" class="card not-found-tracs">
                <img src="../../assets/images/not-found-img.jpg" alt="No SMARTracs Found">
                <p>No SMARTracs Found</p>
              </div>
              <div v-for="(trac, index) in tracs.records" :key="index" class="card">
                <div class="blog-box blog-list px-3">
                  <div class="row">
                    <div class="col-sm-5">
                      <img v-if="trac.coverImageUrl" @error="imageLoadError(trac.id)" :src="trac.coverImageUrl" alt="Ontrac" class="img-fluid sm-100-w">
                      <img v-else src="../../assets/images/default-img.jpg" class="img-fluid sm-100-w" alt="">
                    </div>
                    <div class="col-sm-7">
                      <div class="blog">
                        <h6>
                          {{ trac.title }}
                          <span v-if="userIsAdmin()"> by {{ trac.author }}</span>
                        </h6>
                        <div class="blog-bottom-content">
                          <ul class="blog-social">
                            <li v-if="trac.tracCategories" class="trac-categories">
                              Categories:
                              <span
                                  v-for="(category, idxCategory) in trac.tracCategories.slice(0, 2)"
                                  :key="idxCategory"
                              >
                            {{ category.name }}
                          </span>
                              <span v-if="trac.tracCategories.length > 2" :id="'popover-target-' + trac.id">
                            + {{ trac.tracCategories.length - 2 }}
                          </span>
                              <b-popover :target="'popover-target-' + trac.id" triggers="hover" placement="top">
                            <span class="popover-span" v-for="(category, idxCategory) in trac.tracCategories.slice(2)" :key="idxCategory">
                              {{ category.name.trim() }}
                            </span>
                              </b-popover>
                            </li>
                            <li v-if="trac.isFeatured" class="mt-2">
                              <span class="badge badge-danger">Featured</span>
                            </li>
                            <li class="digits mt-3">
                              <router-link
                                tag="button"
                                :to="{ name: 'trac-view', params: { id: trac.id } }" v-b-tooltip.hover
                                title="See Goal"
                                class="btn btn-primary mr-3"
                              >
                                View Details
                              </router-link>
                              <button v-b-tooltip.hover
                                class="btn btn-light mr-3"
                                title="Edit SMARTracs"
                                @click="openModal(trac)"
                              >
                                <i class="fa fa-edit"></i>
                              </button>
                              <button v-b-tooltip.hover
                                class="btn btn-light mr-3"
                                title="Duplicate SMARTrac"
                                @click="copyTrac(trac)"
                              >
                                <i class="fa fa-copy"></i>
                              </button>
                              <button v-b-tooltip.hover
                                class="btn btn-light mr-3"
                                title="Delete SMARTrac"
                                @click="openModalToDeleteTrac(trac)"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </li>
                          </ul>
                          <hr>
                          <p class="mt-0">{{ trac.briefDescription }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4">
                <b-pagination
                    v-model="pageNumber"
                    :per-page="pageSize"
                    :total-rows="tracs.totalRecords"
                    class="my-0"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="edit-trac" title="Edit SMARTrac" hide-footer size="lg">
      <div class="p-3">
        <div class="row">
          <div class="col-md-7">
            <form @submit.prevent="handleEdit">
              <div class="form-group">
                <label>Title</label>
                <input type="text"
                  v-model="tracEdit.title"
                  class="form-control"
                  :class="{ 'is-invalid': submittedEdit && $v.tracEdit.title.$error }" />
                <div v-if="submittedEdit && !$v.tracEdit.title.required" class="invalid-feedback">
                  Title is required
                </div>
              </div>
              <div class="form-group">
                <label>Category</label>
                <multiselect
                    v-model="tracEdit.categoryIds"
                    :class="{ 'is-invalid': submittedEdit && $v.tracEdit.categoryIds.$error }"
                    tag-placeholder="Add this as new tag"
                    placeholder="You Can Choose More Than One"
                    label="text"
                    track-by="value"
                    :options="categoriesOptions"
                    :multiple="true"
                    :taggable="true"
                ></multiselect>
                <div v-if="submittedEdit && !$v.tracEdit.categoryIds.required" class="invalid-feedback">
                  Category is required
                </div>
              </div>
              <div class="form-group" v-if="userIsAdmin()">
                <label>Author</label>
                <b-form-select class="form-control form-control-primary btn-square"
                  v-model="tracEdit.lifeCoachId"
                  :options="authorsOptions"
                  :class="{ 'is-invalid': submittedEdit && $v.tracEdit.lifeCoachId.$error }">
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select an Author --</b-form-select-option>
                  </template>
                </b-form-select>
                <div v-if="submittedEdit && !$v.tracEdit.lifeCoachId.required" class="invalid-feedback">
                  Author is required
                </div>
              </div>
              <div class="form-group">
                <label>Price</label>
                <input type="number"
                  v-model="tracEdit.price"
                  class="form-control"
                  :class="{ 'is-invalid': submittedEdit && $v.tracEdit.price.$error }"
                  min="0" step=".01" />
                <div v-if="submittedEdit && !$v.tracEdit.price.required" class="invalid-feedback">
                  Price is required
                </div>
              </div>
              <div class="form-group">
                <label>Brief Description</label>
                <input type="text"
                  v-model="tracEdit.briefDescriptionText"
                  class="form-control"
                  :class="{ 'is-invalid': submittedEdit && $v.tracEdit.briefDescriptionText.$error }" />
                <div v-if="submittedEdit && !$v.tracEdit.briefDescriptionText.required" class="invalid-feedback">
                  Brief Description is required
                </div>
              </div>
              <div class="form-group">
                <label>Full Description</label>
                <textarea v-model="tracEdit.fullDescriptionText"
                  rows="3"
                  class="form-control"
                  :class="{ 'is-invalid': submittedEdit && $v.tracEdit.fullDescriptionText.$error }"></textarea>
                <div v-if="submittedEdit && !$v.tracEdit.fullDescriptionText.required" class="invalid-feedback">
                  Full Description is required
                </div>
              </div>
              <div class="form-group">
                <label>Status</label>
                <b-form-select class="form-control form-control-primary btn-square"
                  v-model="tracEdit.status"
                  :options="statusOptions"
                  :class="{ 'is-invalid': submittedEdit && $v.tracEdit.status.$error }">
                </b-form-select>
                <div v-if="submittedEdit && !$v.tracEdit.status.required" class="invalid-feedback">
                  Status is required
                </div>
              </div>
              <div v-if="userIsAdmin()" class="row mb-4">
                <div class="col-6">
                  <div class="checkbox checkbox-dark">
                    <div class="custom-control custom-checkbox pl-1">
                      <b-form-checkbox
                        v-model="tracEdit.isFeatured"
                      >Featured</b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary" :disabled="loadingEdit">Save Changes</button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-5">
            <input type="file" id="tracImage" ref="tracImage" accept="image/x-png,image/jpeg" @change="selectImage" style="position: fixed;z-index: -1;left: -1000px;top: -1000px">
            <label for="tracImage" class="tracImage-label">
              <i class="fa fa-upload"></i>
              <img :src="tracImage" width="100%" alt="" v-if="tracImage">
              <img v-else :src="tracEdit.coverImageUrl" width="100%" alt="">
              <img v-if="!tracImage && !tracEdit.coverImageUrl" src="../../assets/images/default-img.jpg" width="100%" alt="">
            </label>
          </div>
        </div>
      </div>
    </b-modal>
    
    <b-modal ref="delete-trac" title="Delete SMARTrac" hide-footer size="lg">
      <div class="p-3">
        <div class="row mb-5">
          <div class="col-12">
            <label class="d-block mb-3">
              Please, write the exact name of the SMARTrac below in order to delete this record.
            </label>
            <span class="text-to-delete">{{ tracTitleToDelete }}</span>
            <input type="text" class="form-control" v-model="tracTitleWritten" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button @click="deleteTrac()" class="btn btn-primary">
              DELETE
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <div class="recognition-modal-wrapper" :class="{'open': recognition}">
      <div class="recognition-modal">
        <div class="row">
          <div class="col-md-4 help-circle-icon">
            <i class="help-circle-icon-middle fa fa-question-circle-o"></i>
          </div>
          <div class="col-md-8">
            <p>
              This SMARTrac builder is a guided tool to help you create a SMARTrac. Our team designed the tool to simplify the SMARTrac design process for you.<br>
              Similar to creating an outline for a book or other content, designing a SMARTrac can take some time. Don’t feel that you need to finish it in one session. You can save as you go, come back and edit as often as you need before submitting your SMARTrac as complete.
            </p>
            <p class="one-note">
              Also one note: For the best experience, we recommend creating your SMARTrac on a desktop or laptop computer. You can also use a tablet, however, it is not designed for mobile or smartphone use
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-end pt-3">
            <button type="button" class="btn btn-primary text-center" @click="closeModal">Got it</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "../../components/loading";
  import moment from "moment"
  import { required, maxLength, requiredIf } from "vuelidate/lib/validators";
  import zapier from "../../services/zapier";
  import Multiselect from 'vue-multiselect';

  export default {
    name: "trac-page",
    components: {
      Loading,
      Multiselect
    },
    data() {
      return {
        recognition: false,
        userInfo: '',
        tracImage: '',
        loadingCreate: false,
        loadingUpload: false,
        loadingEdit: false,
        loadingDelete: false,
        search: {
          author: null,
          category: null,
          term: '',
        },
        pageNumber: 1,
        pageSize: 20,
        tracs: {
          totalRecords: 0,
          records: [],
        },
        imageData: '',
        loading: true,
        trac: {
          title: "",
          lifeCoachId: null,
          briefDescription: "",
          fullDescription: "",
          coverImageUrl: "",
          price: null,
          isFeatured: false,
          categoryIds: null
        },
        tracEdit: {
          title: "",
          lifeCoachId: null,
          briefDescriptionText: "",
          fullDescriptionText: "",
          coverImageUrl: null,
          price: null,
          status: null,
          isFeatured: false,
          categoryIds: null
        },
        submitted: false,
        submittedEdit: false,
        authorsOptions: [],
        statusOptions: [
          { value: 0, text: 'Draft' },
          { value: 1, text: 'Public' },
          { value: 2, text: 'Unlisted' },
        ],
        categoriesOptions: [],
        daysOfWeekOptions: [
          { dayName: 'Sunday', text: 'Sun'},
          { dayName: 'Monday', text: 'Mon'},
          { dayName: 'Tuesday', text: 'Tues'},
          { dayName: 'Wednesday', text: 'Wed'},
          { dayName: 'Thursday', text: 'Thurs'},
          { dayName: 'Friday', text: 'Fri'},
          { dayName: 'Saturday', text: 'Sat'},
        ],
        daysOfWeek: '',
        tracToDelete: null,
        tracTitleToDelete: '',
        tracTitleWritten: '',
      }
    },
    validations: {
      trac: {
        title: { required },
        categoryIds: { required },
        lifeCoachId: {
          required: requiredIf(function() {
            return this.userIsAdmin();
          })
        },
        price: { required },
        briefDescription: { required, maxLength: maxLength(200) },
        fullDescription: { required },
      },
      tracEdit: {
        title: { required },
        categoryIds: { required },
        lifeCoachId: {
          required: requiredIf(function() {
            return this.userIsAdmin();
          })
        },
        price: { required },
        briefDescriptionText: { required, maxLength: maxLength(200) },
        fullDescriptionText: { required },
      }
    },
    methods: {
      getCategoryIds(data = []) {
        let ids = [];

        data.forEach((val) => {
          ids.push(val.value)
        });

        return ids;
      },
      closeModal() {
        this.recognition = false;
        localStorage.setItem('recognition', true)
      },
      selectImage() {
        if (this.$refs.tracImage.files[0].type === 'image/png' || this.$refs.tracImage.files[0].type === "image/jpeg") {
          this.getBase64(this.$refs.tracImage.files[0], (res) => {
            this.tracImage = res
          })
        }
        else {
          this.toaster('error', 'Please select only images');
        }
      },
      getBase64 (file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          cb(reader.result);
        };
        reader.onerror = function (error) {
          console.log("Error: ", error);
        };
      },
      handleFileUploadAvatar(Id, callback) {
        if (!this.$refs.tracImage.files.length) {
          callback()
          return
        }
        this.loadingUpload = true;
        let FileName = this.$refs.tracImage.files[0].name;

        this.getBase64(this.$refs.tracImage.files[0], (res) => {
          const obj = {
            Id,
            FileName,
            FileData: res.substring(res.indexOf(",") + 1),
          };

          return this.$store.dispatch('uploadTracImage', obj).then(() => {
            this.toaster('success', 'Successfully uploaded');
            this.loadingUpload = false;
            this.tracImage = "";
            this.imageData = "";
            callback()
          }).catch(() => {
            this.toaster('error', 'Please try again');
            this.loadingUpload = false;
            callback()
          });
        });
      },
      copyTrac(trac) {
        this.$swal({
          text:'Are you sure you want to do copy "' + trac.title + '"?',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#4466f2',
          cancelButtonText: 'Cancel',
          cancelButtonColor: '#efefef',
          reverseButtons: true
        }).then((val) => {
          if (val.value) {
            this.$store.dispatch('copyTrac', trac).then(() => {
              this.toaster('success', 'Successfully done');
              this.getTracs();
            }).catch(() => {
              this.toaster('error', 'Please try again');
            })
          }
        })
      },
      openModal(tracItem) {
        this.$refs['edit-trac'].show();

        this.tracEdit = {
          id: tracItem.id,
          title: tracItem.title,
          lifeCoachId: tracItem.lifeCoachId.toLowerCase(),
          briefDescriptionText: tracItem.briefDescription,
          fullDescriptionText: tracItem.fullDescription,
          coverImageUrl: tracItem.coverImageUrl,
          price: tracItem.price,
          status: tracItem.status,
          isFeatured: tracItem.isFeatured,
          categoryIds: tracItem.tracCategories ? tracItem.tracCategories.map(record => {
            return {
              value: record.id,
              text: record.name,
            }
          }) : []
        }
      },
      async getTracs() {
        this.loading = true;
        this.tracs.totalRecords = 0;
        this.tracs.records = [];

        let payload = {
          author: this.search.author ? this.search.author : '',
          category: this.search.category ? this.search.category : '',
          term: this.search.term ? this.search.term : '',
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        };

        this.$router.replace({ name: "trac", query: {...payload} })

        this.$store.dispatch('getTracs', payload)
        .then(async(val) => {
          if (val.data.result && val.data.result.records) {
            this.tracs.totalRecords = val.data.result.totalRecords;

            this.tracs.records = val.data.result.records.map(record => {
              return {
                id: record.id,
                title: record.title,
                author: record.author,
                createdBy: record.createdBy,
                creationDate: record.creationDate,
                price: record.price,
                briefDescription: record.briefDescription,
                fullDescription: record.fullDescription,
                isEnabled: record.isEnabled,
                isPublic: record.isPublic,
                status: record.status,
                isFeatured: record.isFeatured,
                lifeCoachId: record.lifeCoachId,
                tracCategories: record.tracCategories,
                coverImageUrl: record.coverImageUrl,
                slug: record.slug
              }
            });
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      },
      async getAuthorsDropdown() {
        this.authorsOptions = [];

        this.$store.dispatch('getAuthorsDropdown')
        .then(async(val) => {
          if (val.data.result) {
            this.authorsOptions = val.data.result.map(record => {
              return {
                value: record.id,
                text: record.author
              }
            });
          }
        });
      },
      async getCategoriesDropdown() {
        this.categoriesOptions = [];

        this.$store.dispatch('getCategoriesDropdown')
        .then(async(val) => {
          if (val.data.result) {
            this.categoriesOptions = val.data.result.map(record => {
              return {
                value: record.id,
                text: record.category
              }
            });
          }
        });
      },
      handleSubmit() {
        this.submitted = true;
        this.loadingCreate = true;

        this.$v.trac.$touch();
        if (this.$v.trac.$invalid) {
          this.loadingCreate = false;
          return;
        }

        let categories = this.getCategoryIds(this.trac.categoryIds);

        this.$store.dispatch('createTrac', {
          ...this.trac,
          categoryIds: categories
        })
        .then(async(val) => {
          if (val.data.statusCode === 200) {
            this.$v.trac.$reset();

            this.trac = {
              title: "",
              categoryIds: null,
              lifeCoachId: null,
              briefDescription: "",
              fullDescription: "",
              coverImageUrl: null
            };

            this.toaster('success', val.data.result.message);
            this.getTracs();

            if (val.data.result.isFirstTime) {
              let userinfo = localStorage.getItem('userinfo');
              await zapier.createFirstSMARTrac(JSON.parse(userinfo));
            }
          }
          else {
            this.toaster('error', val.data.result);
          }

          this.submitted = false;
          this.loadingCreate = false;
        })
        .catch(async(val) => {
          const message = this.formatExceptionMessage(val);
          this.toaster('error', message);

          this.loadingCreate = false;
        });
      },
      async handleEdit() {
        this.submittedEdit = true;
        this.loadingEdit = true;

        this.$v.tracEdit.$touch();
        if (this.$v.tracEdit.$invalid) {
          this.loadingEdit = false;
          return;
        }

        let data = {
          id: this.tracEdit.id,
          title: this.tracEdit.title,
          lifeCoachId: this.tracEdit.lifeCoachId,
          price: this.tracEdit.price,
          briefDescription: this.tracEdit.briefDescriptionText,
          fullDescription: this.tracEdit.fullDescriptionText,
          coverImageUrl: this.tracEdit.coverImageUrl,
          status: this.tracEdit.status,
          isFeatured: this.tracEdit.isFeatured,
          categoryIds: this.getCategoryIds(this.tracEdit.categoryIds)
        };

        this.$store.dispatch('updateTrac', data)
        .then(async(val) => {
          if (val.data.statusCode === 200) {
            this.handleFileUploadAvatar(this.tracEdit.id, () => {
              this.toaster('success', val.data.result);
              this.$refs['edit-trac'].hide();
              this.submittedEdit = false;
              this.loadingEdit = false;
              this.getTracs();
            })
          }
          else {
            this.toaster('error', val.data.result);
            this.submittedEdit = false;
            this.loadingEdit = false;
          }
        })
        .catch(async(val) => {
          const message = this.formatExceptionMessage(val);
          this.toaster('error', message);

          this.submittedEdit = false;
          this.loadingEdit = false;
        });
      },
      openModalToDeleteTrac(trac) {
        this.tracToDelete = trac;
        this.tracTitleToDelete = trac.title;

        this.$refs['delete-trac'].show();
      },
      deleteTrac() {
        const writtenTitle = this.tracTitleWritten.trim().toLowerCase();
        const actualTitle = this.tracTitleToDelete.replace(/\s+/g, ' ').trim().toLowerCase();
        
        if (writtenTitle !== actualTitle) {
          this.$swal({
            text: 'The written SMARTrac Name does not match the actual SMARTrac Name.',
          });

          return;
        }
        
        this.tracTitleWritten = '';
        this.$refs['delete-trac'].hide();
        this.handleDelete(this.tracToDelete);
      },
      handleDelete(trac) {
        this.loadingDelete = true;

        this.$store.dispatch('deleteTrac', trac)
        .then(async(val) => {
          if (val.data.statusCode === 200) {
            this.toaster('success', val.data.message);
            this.getTracs();
          }
          else {
            this.toaster('error', val.data.result);
          }

          this.loadingDelete = false;
        })
        .catch(async(val) => {
          const message = this.formatExceptionMessage(val);
          this.toaster('error', message);

          this.loadingDelete = false;
        });
      },
      moment(date) {
        return `<span>${moment(date).format('D')}</span> ${moment(date).format('MMMM')} ${moment(date).format('YYYY')}`
      },
      imageLoadError(id) {
        for (const [key, value] of Object.entries(this.tracs)) {
          if (value.id === id) {
            value.key = key;
            value.coverImageUrl = require('../../assets/images/default-img.jpg')
          }
        }
      },
      formatExceptionMessage(val) {
        const resp = val.response.data;
        return resp.responseException && resp.responseException.exceptionMessage ? resp.responseException.exceptionMessage : 'Please try again';
      },
      toaster(type, message) {
        this.$toasted.show(message, {
          theme: 'bubble',
          position: 'top-right',
          type: type,
          duration: 3000
        });
      },
      userIsAdmin() {
        const user = JSON.parse(localStorage.getItem('userinfo'));
        const roles = user.roles ? user.roles.concat(this.$store.state.userRoles) : this.$store.state.userRoles;

        if (roles && roles.includes('Administrator')) {
          return true;
        }

        return false;
      }
    },
    mounted() {
      this.recognition = !localStorage.getItem('recognition');
      this.search = {
        author: this.$route.query.author || null,
        category: this.$route.query.category || null,
        term: this.$route.query.term || '',
      }
      this.pageNumber = +this.$route.query.pageNumber || 1
      this.pageSize = +this.$route.query.pageSize || 20

      this.getTracs();
      this.userInfo = JSON.parse(localStorage.getItem('userinfo'));

      this.getAuthorsDropdown();
      this.getCategoriesDropdown();
    },
    watch: {
      pageNumber: {
        handler: function() {
          this.getTracs();
          window.scrollTo(0, 0);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .recognition-modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000000a3;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
    opacity: 0;
    transition: .4s;

    &.open {
      visibility: visible;
      opacity: 1;
    }

    .recognition-modal {
      max-width: 800px;
      background: white;
      padding: 40px;
      border-radius: 15px;
      overflow: hidden;

      p {
        font-size: 16px;
      }

      .one-note {
        background: #0037ff0a;
        padding: 6px 10px;
      }

      .help-circle-icon {
        position: relative;

        .help-circle-icon-middle {
          width: 300px;
          position: absolute;
          right: 40px;
          top: 50%;
          transform: translateY(-50%);
          color: #3e58bc;
          font-size: 350px;
        }
      }
    }
  }

  .blog-details {
    padding: 40px 0;
  }

  .custom-select {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }

  .tracImage-label {
    position: relative;

    i {
      position: absolute;
      background-color: #fff;
      color: #000;
      padding: 10px;
      margin: 10px;
      bottom: 0;
      right: 0;
      font-size: 20px;
      border-radius: 5px;
      cursor: pointer;
    }
  }

  .trac-list-title {
    margin-top: 40px;

    h3 {
      font-size: 23px;
      margin-bottom: 20px;
      font-weight: 600;
      line-height: 1;
    }
  }

  .smart-tracs-wrapper {
    padding-top: 40px;

    .card {
      position: relative;

      .help-circle-icon-middle {
        position: absolute;
        right: 20px;
        top: -15px;
        background: #f6f6f6;
        padding: 0;
        border-radius: 50%;
        color: #4466f2;
        width: 30px;
        cursor: pointer;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #4466f2;
        font-size: 18px;
        z-index: 1;
      }
    }
  }

  .delete-trac:hover {
    background-color: #ff5370 !important;
    border-color: #ff5370 !important;
    color: #fff !important;
  }

  .not-found-tracs {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 430px;

    img {
      width: 200px;
    }

    p {
      font-size: 17px;
    }
  }

  ::v-deep .multiselect__tags {
    border: 1px solid #ced4da;
  }

  .trac-categories {
    span {
      background: #ffffff;
      color: #4466f2;
      padding: 2px 10px;
      line-height: 1;
      border-radius: 4px;
      border: 1px solid;
      margin: 3px 4px;
      display: inline-block;
      user-select: none;
    }
  }

  .popover-span {
    &:after {
      content: ', ';
    }
    &:last-child {
      &:after {
        content: '';
      }
    }
  }

  .blog-box h6 {
    span {
      font-weight: 400;
      color: #717171;
    }
  }

  @media screen and (max-device-width: 1366px) and (min-device-width: 1200px) {
    .blog-bottom-content {
      display: block !important;
    }
  }

  .text-to-delete {
    display: block;
    background-color: #ededed;
    border: #d8d8d8 solid 1px;
    padding: 8px 15px;
    border-radius: 7px;
    margin-bottom: 20px;
    font-family: 'Courier New', Courier, monospace;
  }
</style>
